var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomConcierge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 60 60",
    fill: "#260e00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.5662,75.8381H24.7918c-.9395,0-1.7012-.7617-1.7012-1.7012s.7617-1.7012,1.7012-1.7012h50.7744c.9395,0,1.7012.7617,1.7012,1.7012s-.7617,1.7012-1.7012,1.7012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2742,69.9534H22.7254c-.7383,0-1.4033-.4385-1.6953-1.1162-.2617-.6084-.1768-1.3008.209-1.8232l5.7812-8.7246h45.96l5.7812,8.7246c.3857.5225.4707,1.2148.209,1.8223-.292.6787-.958,1.1172-1.6963,1.1172ZM25.6258,66.551h48.749l-3.2207-4.8594H28.8465l-3.2207,4.8594Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8367,60.5315h-3.4023c0-11.2676-9.167-20.4346-20.4346-20.4346s-20.4346,9.167-20.4346,20.4346h-3.4023c0-13.1436,10.6934-23.8369,23.8369-23.8369s23.8369,10.6934,23.8369,23.8369Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1229,34.717h-10.2451c-.9922,0-1.7998-.8076-1.7998-1.7998v-1.833c0-1.873.7363-3.627,2.0732-4.9395,1.3359-1.3115,3.0879-2.0029,4.9775-1.9805,3.7461.0684,6.7939,3.251,6.7939,7.0938v1.6592c0,.9922-.8076,1.7998-1.7998,1.7998ZM46.4803,31.3147h7.04v-.0566c0-2.001-1.5488-3.6582-3.4541-3.6934-.9834.0146-1.8525.3418-2.5322,1.0078-.6797.667-1.0537,1.5596-1.0537,2.5117v.2305Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2986,
    y: 32.2512,
    width: 3.4023,
    height: 6.1445
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomConcierge);
export default __webpack_public_path__ + "static/media/custom_concierge.68053a3832afe9b138872e5085ef7fc4.svg";
export { ForwardRef as ReactComponent };